import { IHttpRequest } from  "@/interfaces/IHttp";
import { container, TYPES } from  "@/inversifyconfig/container.config";


const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 

export async function getMyUserProfile(): Promise<any> {
    const res = await http.get("user/me/profile");
    
    if(res.data) {
        return Promise.resolve(res.data)
    }
    
    return Promise.reject(new Error(`Couldn't get activity feed data`))
}